import { useResultPopupModuleDispatch, RESULT_POPUP_MODULE_ACTION } from "..";
import { useCallback } from "react";

export default function useHidePopup() {
    const dispatch = useResultPopupModuleDispatch();

    return useCallback(() => {
        dispatch({
            type: RESULT_POPUP_MODULE_ACTION.HIDE
        })
    }, [dispatch])
}
